"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class ConfigurationFormValidator {
    static maxGeschwindigkeit(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.VelocityUnits.m_s;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.VelocityUnits.fpm;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static beschleunigungMax(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.AccelerationUnits.m_s2;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.AccelerationUnits.ft_s2;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static doppelhuebe(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.FrequencyUnits._h;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.FrequencyUnits._h;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static aussermittigerFestpunkt(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.CEIL_ABSOLUTE_VALUE,
            thresholdMin: 0,
            thresholdMax: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL_ABSOLUTE_VALUE,
            thresholdMin: 0,
            thresholdMax: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityRangeValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static minTemperaturValidator(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            thresholdMin: -273.15,
            thresholdMax: 1000,
        });
        const metricUnit = echain_shared_quantities_1.TemperatureUnits.celsius;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            thresholdMin: -459.67,
            thresholdMax: 1832,
        });
        const imperialUnit = echain_shared_quantities_1.TemperatureUnits.fahrenheit;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityRangeValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static maxTemperaturValidator(options) {
        return this.minTemperaturValidator(options);
    }
    static durchschnittTemperaturValidator(options) {
        return this.minTemperaturValidator(options);
    }
    static bauraumbreite(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static bauraumhoehe(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static bauraumlaenge(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static maxAussenhoehe(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static minInnenbreite(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static minInnenhoehe(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static minKettenBiegeradius(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.FLOOR,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
}
exports.ConfigurationFormValidator = ConfigurationFormValidator;
//# sourceMappingURL=ConfigurationFormValidator.js.map